import { useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";

export const useBrandsList = (
  selectedGroups?: (string | number)[],
  vdbSetting?: boolean,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["brands_list", selectedGroups, vdbSetting],
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const params: any = {};

      if (selectedGroups && selectedGroups.length > 0) {
        params["group_ids[]"] = selectedGroups;
      }

      // Add vdb setting
      if (vdbSetting) {
        params.vdb_setting = true;
      }

      const res = await apiClient.get(Routes.GET_BRANDS_LIST, { params });

      return res.data.data;
    },
    staleTime: Infinity, // Load once, never refetch unless groups change
  });
};

export const useGetAllBrandsList = (
  selectedGroups?: (string | number)[],
  vdbSetting?: boolean,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: ["brands_list", selectedGroups, vdbSetting],
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const params: any = {};

      if (selectedGroups && selectedGroups.length > 0) {
        params["group_ids[]"] = selectedGroups;
      }

      // Add vdb setting
      if (vdbSetting) {
        params.vdb_setting = true;
      }

      const res = await apiClient.get(Routes.GET_ALL_BRANDS, { params });

      return res.data.data;
    },
    staleTime: Infinity, // Load once, never refetch unless groups change
  });
};
